(ns dnd.ui.icons
  (:require [dnd.util :refer [make-uuid]]))

(defn ai
  [{:keys [size]}]
  {:pre [(or (number? size)
             (string? size))]}
  [:svg {:data-icon-name "ai"
         :width size
         :height size
         :viewBox "0 0 24 35"
         :fill "none"
         :xmlns "http://www.w3.org/2000/svg"}
   [:g {:clip-path "url(#clip0_1_25)"}
    [:path {:fill-rule "evenodd"
            :clip-rule "evenodd"
            :d "M13.5736 0.278814C13.6926 0.267714 13.8086 0.321114 13.8776 0.418814C13.9466 0.516514 13.9586 0.643714 13.9076 0.752214L9.0636 11.0678C9.0076 11.1771 9.0196 11.3087 9.0936 11.4065C9.1676 11.5044 9.29059 11.5512 9.41159 11.5272L16.2606 10.135C16.3986 10.0843 16.5536 10.1344 16.6366 10.2564C16.7186 10.3783 16.7076 10.5408 16.6086 10.6501L2.45059 34.6781C2.36659 34.8222 2.1896 34.8824 2.0356 34.8193C1.8816 34.7562 1.79759 34.589 1.83859 34.4275L5.68059 18.1119C5.70659 18.0014 5.6746 17.8855 5.5956 17.8039C5.5166 17.7224 5.40159 17.6863 5.29059 17.7082L0.404603 18.8079C0.291603 18.8386 0.171592 18.8054 0.0905919 18.7213C0.00859194 18.6373 -0.0204121 18.5158 0.0145879 18.4042L5.0266 1.30901C5.0666 1.18381 5.1746 1.09222 5.3046 1.07232L13.5736 0.278814ZM22.7196 8.93781C22.8536 8.88681 23.0056 8.92661 23.0966 9.03681C23.1876 9.14701 23.1986 9.30322 23.1236 9.42512L8.93759 33.453C8.84659 33.5767 8.68259 33.6218 8.54059 33.5624C8.39859 33.503 8.3156 33.3544 8.3396 33.2024L9.4256 28.6084L20.7576 9.31371L22.7196 8.93781ZM19.3376 0.000413727C19.4536 -0.00538627 19.5656 0.0501134 19.6306 0.146913C19.6956 0.243713 19.7066 0.367615 19.6576 0.473715L15.7596 8.14432L13.8386 8.47841C13.7166 8.49521 13.5956 8.44411 13.5236 8.34541C13.4506 8.24661 13.4376 8.11601 13.4906 8.00511L17.4716 0.139612L19.3376 0.000413727Z"
            :fill "currentColor"}]]
   [:defs
    [:clipPath {:id "clip0_1_25"}
     [:rect {:width "24" :height "35" :fill "white"}]]]])

(defn hubspot
  [{:keys [size]}]
  {:pre [(number? size)]}
  [:svg {:data-icon-name "hubspot"
         :viewBox "0 0 16 16"
         :height size
         :data-test-id "icon-hubspot-logo"}
   [:title "HubSpot"]
   [:path {:d "M11.6127 10.9174C10.4763 10.9174 9.55512 10.0374 9.55512 8.95201C9.55512 7.86645 10.4763 6.98646 11.6127 6.98646C12.749 6.98646 13.6702 7.86645 13.6702 8.95201C13.6702 10.0374 12.749 10.9174 11.6127 10.9174ZM12.2286 5.16801V3.41954C12.7064 3.20397 13.041 2.74229 13.041 2.20648V2.16612C13.041 1.42664 12.4077 0.821619 11.6336 0.821619H11.5915C10.8174 0.821619 10.1841 1.42664 10.1841 2.16612V2.20648C10.1841 2.74229 10.5187 3.20416 10.9965 3.41972V5.16801C10.2852 5.27306 9.63527 5.55332 9.09927 5.96578L4.07384 2.23138C4.107 2.10973 4.1303 1.9845 4.1305 1.85286C4.13129 1.0155 3.42174 0.335606 2.54479 0.334474C1.66822 0.333532 0.956311 1.01154 0.955323 1.84909C0.954337 2.68665 1.66388 3.36654 2.54084 3.36748C2.82651 3.36786 3.09106 3.29035 3.32283 3.16436L8.26614 6.83803C7.84582 7.44418 7.59944 8.17028 7.59944 8.95201C7.59944 9.77033 7.8701 10.5274 8.32734 11.1499L6.82415 12.5861C6.7053 12.5519 6.58211 12.5282 6.45141 12.5282C5.73101 12.5282 5.14684 13.086 5.14684 13.7742C5.14684 14.4626 5.73101 15.0205 6.45141 15.0205C7.17201 15.0205 7.75599 14.4626 7.75599 13.7742C7.75599 13.6498 7.73112 13.5319 7.69538 13.4184L9.18238 11.9978C9.85738 12.4899 10.698 12.7856 11.6127 12.7856C13.8292 12.7856 15.6257 11.0692 15.6257 8.95201C15.6257 7.03531 14.1517 5.45185 12.2286 5.16801Z"
           :fill "#FF7A59"}]])

(defn avatar-person
  [{:keys [size]}]
  {:pre [(or (number? size)
             (string? size))]}
  (let [mask-id (make-uuid)]
    [:svg {:data-icon-name "avatar-person" :width size :height size :viewBox "0 0 80 80" :fill "none" :xmlns "http://www.w3.org/2000/svg"}
     [:mask {:id mask-id :maskUnits "userSpaceOnUse" :x "0" :y "0" :width "80" :height "80"}
      [:circle {:cx "40" :cy "40" :r "40" :fill "white"}]]
     [:g {:mask (str "url(#" mask-id ")")}
      [:circle {:cx "40" :cy "38" :r "12" :fill "currentColor"}]
      [:path {:d "M40.5 52C26.969 52 16 64.536 16 80H40.5H65C65 64.536 54.031 52 40.5 52Z" :fill "currentColor"}]]]))

(defn chart-icon
  [{:keys [size]}]
  [:svg {:data-icon-name "chart-icon" :width size :height size :viewBox "0 0 50 50" :fill "none" :xmlns "http://www.w3.org/2000/svg"}
   [:rect {:x "16.5667" :y "9.56672" :width "16.8666" :height "8.86657" :rx "0.566717" :fill "currentColor" :fill-opacity "0.2" :stroke "currentColor" :stroke-width "1.13343"}]
   [:rect {:x "3.56672" :y "26.5667" :width "16.8666" :height "8.86657" :rx "0.566717" :fill "currentColor" :fill-opacity "0.2" :stroke "currentColor" :stroke-width "1.13343"}]
   [:rect {:x "29.5667" :y "26.5667" :width "16.8666" :height "8.86657" :rx "0.566717" :fill "currentColor" :fill-opacity "0.2" :stroke "currentColor" :stroke-width "1.13343"}]
   [:path {:d "M25 19V23M25 23H12V26.5M25 23H38.5V26.5" :stroke "currentColor" :stroke-linejoin "round"}]])

(defn hs-add-icon
  []
  [:svg {:data-icon-name "add-icon" :viewBox "0 0 32 32" :fill "none" :xmlns "http://www.w3.org/2000/svg"}
   [:g {:clip-path "url(#clip0_1334_527)"}
    [:path {:d "M2.08167 18.05H13.8865V29.9183C13.8865 31.0683 14.8182 32 15.9682 32C17.1182 32 18.0499 31.0683 18.0499 29.9183V18.1134H29.8548C31.0048 18.1134 31.9365 17.1818 31.9365 16.0317C31.9365 14.8817 31.0048 13.95 29.8548 13.95H18.0499V2.08171C18.0499 0.931694 17.1182 0 15.9682 0C14.8182 0 13.8865 0.931694 13.8865 2.08171V13.8866H2.08167C0.931648 13.8866 -4.57764e-05 14.8182 -4.57764e-05 15.9683C-4.57764e-05 17.1183 0.931648 18.05 2.08167 18.05Z"
            :fill "currentColor"}]]
   [:defs
    [:clipPath {:id "clip0_1334_527"}
     [:rect {:width "32" :height "32" :fill "white"}]]]])

(defn hs-minus-icon
  []
  [:svg {:data-icon-name "minus-icon" :viewBox "0 0 32 32" :fill "none" :xmlns "http://www.w3.org/2000/svg"}
   [:g {:clip-path "url(#clip0_133_90)"}
    [:path {:d "M2.08171 18.05H13.8866L18.05 18.1135H29.8548C31.0048 18.1135 31.9365 17.1818 31.9365 16.0318C31.9365 14.8818 31.0048 13.9501 29.8548 13.9501H18.05L13.8866 13.8866H2.08171C0.931694 13.8866 0 14.8183 0 15.9683C0 17.1183 0.931694 18.05 2.08171 18.05Z"
            :fill "currentColor"}]]
   [:defs
    [:clipPath {:id "clip0_133_90"}
     [:rect {:width "32" :height "32" :fill "white"}]]]])

(defn hs-remove-icon
  []
  [:svg {:aria-hidden "true"
         :xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 32 32"
         :width "100%"
         :height "100%"
         :focusable "false"
         :data-icon-name "Remove"}
   [:path {:d "M27.86 29c-.29 0-.58-.11-.81-.33L4.19 5.81a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l22.86 22.86a1.14 1.14 0 0 1-.81 1.95"}]
   [:path {:d "M5 29c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62L27.05 4.19a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L5.81 28.67c-.22.22-.52.33-.81.33"}]])
